import React, { useEffect, useState } from 'react';
import { database, auth } from '../modules/fireBase';
import { Layout, Menu } from 'antd';
import '../assets/styles/Home.css';
import calendarImg from '../assets/images/6274.png';

import CustomLayout from './CustomLayout';

export default function Home() {
  useEffect(() => {}, []);
  return (
    <CustomLayout
      selectedKey="1"
      contentStyle={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <img src={calendarImg} alt="Calendar Image" style={{ maxHeight: 300 }} />
    </CustomLayout>
  );
}
